import { render, staticRenderFns } from "./transferProgramForm.vue?vue&type=template&id=73ca3962&"
import script from "./transferProgramForm.vue?vue&type=script&lang=js&"
export * from "./transferProgramForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports